import { render } from "./banerPage.vue?vue&type=template&id=2b74aed8&scoped=true"
import script from "./banerPage.vue?vue&type=script&lang=js"
export * from "./banerPage.vue?vue&type=script&lang=js"

import "./banerPage.vue?vue&type=style&index=0&id=2b74aed8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b74aed8"]])

export default __exports__